import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  annualBillingToggle: {
    defaultMessage: 'Annual billing',
    description: 'Label for toggle to view annual billing plans',
    id: 'z8rgwZ',
  },
  upgradePromotionHeader: {
    defaultMessage: 'Upgrade your plan to unlock new features',
    description: 'Header text for promotional banner encouraging plan upgrades',
    id: 'eX1gxn',
  },
  upgradePromotionSubheader: {
    defaultMessage: 'Based on your interest, we suggest upgrading to the plan below.',
    description: 'Subheader text for promotional banner with upgrade suggestion',
    id: 'Azudh5',
  },
  monthlyBillingOption: {
    defaultMessage: 'Pay Monthly',
    description: 'Label for monthly billing option in segmented control',
    id: 'qURIt8',
  },
  annualBillingOption: {
    defaultMessage: 'Pay Annually',
    description: 'Label for annual billing option in segmented control',
    id: 'dxlKWb',
  },
  annualSavingsBadge: {
    defaultMessage: 'Save {percent}%',
    description: 'Savings badge inside annual billing segment',
    id: 'qsFUYr',
  },
  unableToChangePlanBannerHeader: {
    defaultMessage: 'Unable to Change Plan',
    description: 'Header for error banner shown when annual billing user tries to switch to monthly plan',
    id: 'yvZctN',
  },
  unableToChangePlanBannerBody: {
    defaultMessage: 'To switch to a monthly plan, please contact Customer Support.',
    description: 'Body for error banner shown when annual billing user tries to switch to monthly plan',
    id: '//nZiO',
  },
});
